import ExcelJS from 'exceljs';

// Excel Headers Configuration
export const tableHeader = [
  {
    A: "",
    B: "Project",
    C: "Slip Date",
    D: "Plant",
    E: "Slip No ",
    F: "Cancelled",
    G: "Joint",
    H: "WPS No",
    I: "Process",
    J: "Type",
    K: "Welder Code",
    L: "Welder Name",
  },
];

export const prodReportHeader = [
  {
    A: "",
    B: "Project",
    C: "Slip Date",
    D: "Plant",
    E: "Slip No ",
    F: "Cancel Status",
    G: "Joint Type",
    H: "WPS",
    I: "Process",
    J: "Type",
    K: "Welder Code",
    L: "Welder Name",
    M: "Slip Created By",
    N: "Item Code",
    O: "Item Desc",
    P: "Item Group",
    Q: "WCinKgs",
    R: "WMinKgs",
  },
];

export const WQChartHeader = [
  {
    A: "",
    B: "Welder Code",
    C: "WPQ No",
    D: "Welder Name",
    E: "Process Category",
    F: "Type",
    G: "Valid Upto",
    H: "P No to P No Base Material",
    I: "F No",
    J: "Groove Plate Pipe above 610mm",
    K: "Groove Pipe 73mm to 610mm",
    L: "Groove Pipe less than 73mm",
    M: "Fillet Plate Pipe above 610mm",
    N: "Fillet Pipe 73mm to 610mm",
    O: "Fillet Pipe less than 73mm",
    P: "Max Weld Metal Thickness in mm",
    Q: "Minimum Pipe Diameter in mm",
    R: "Backing",
    S: "Backing Gas",
    T: "Welding Progression",
    U: "Inspection",
    V: "Arc Transfer Mode",
    W: "Direct Remote Visual Control",
    X: "Automatic Joint Tracking",
    Y: "With/Without filler wire",
    Z: "Consumable Insert",
    AA: "Filler Metal Product Form (GTAW)",
    AB: "Current/Polarity",
    AC: "Single Pass/Multiple Pass per side (Machine)",
    AD: "Plant",
    AE: "Status"
  },
];

export const WQChartHeaderOverlay = [
  {
    A: "",
    B: "Welder Code",
    C: "WPQ No",
    D: "Welder Name",
    E: "Process Category",
    F: "Type",
    G: "Valid Upto",
    H: "P No to P No Base Material",
    I: "F No",
    J: "Overlay Plate Pipe above 610mm",
    K: "Overlay Pipe 73mm to 610mm",
    L: "Overlay Pipe less than 73mm",
    M: "Minimum Base Metal thk for overlay in mm",
    N: "Minimum Pipe Diameter in mm",
    O: "Backing",
    P: "Backing Gas",
    Q: "Welding Progression",
    R: "Inspection",
    S: "Arc Transfer Mode",
    T: "Direct Remote Visual Control",
    U: "Automatic Joint Tracking",
    V: "With/Without filler wire",
    W: "Consumable Insert",
    X: "Filler Metal Product Form (GTAW)",
    Y: "Current/Polarity",
    Z: "Single Pass/Multiple Pass per side (Machine)",
    AA: "Plant",
    AB: "Status"
  },
];

export const WQChartHeaderTTS = [
  {
    A: "",
    B: "Welder Code",
    C: "WPQ No",
    D: "Welder Name",
    E: "Process Category",
    F: "Type",
    G: "Valid Upto",
    H: "Width of Ligament",
    I: "Joint Type",
    J: "Tube Diameter in mm",
    K: "Tube Thickness in mm",
    L: "Range Qualified Tube Thickness",
    M: "Range Qualified Tube Diameter",
    N: "Tube Pitch",
    O: "Groove Depth",
    P: "Tube Projection",
    Q: "Width of Ligament",
    R: "Pattern",
    S: "Groove Angle/Radius",
    T: "P no",
    U: "F no",
    V: "A no",
    W: "PrePlaced Filler Metal ",
    X: "With/Without Filler Metal",
    Y: "Filler Metal Product Form",
    Z: "Inserts",
    AA: "No of Passes",
    AB: "Position",
    AC: "Progression",
    AD: "Current and Polarity",
    AE: "Automatic Arc Voltage Control System",
    AF: "Amperage(Range Qualified)-root pass",
    AG: "Amperage(Range Qualified)-final pass",
    AH: "Plant",
    AI: "Status"
  },
];

// Excel Export Function
export async function ExportToExcel(
  fileName,
  colwidth,
  excelData,
  Data,
  rangeConfig,
  Headings,
  reportConfig
) {
  const { titleCell, titleWelderRange, tbodyHeadRange, tbodyRange, blankRow } =
    rangeConfig;
  const { sheetName, reporName, type } = reportConfig;

  try {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet(sheetName);

    // Get header data based on report type
    let headerData;
    
    if (reporName === "ProdReport") {
      headerData = prodReportHeader[0];
    } else if (reporName === "WQChartReport") {
      if (type === "Tubesheet") {
        headerData = WQChartHeaderTTS[0];
      } else if (type === "Overlay") {
        headerData = WQChartHeaderOverlay[0];
      } else {
        headerData = WQChartHeader[0];
      }
    } else {
      headerData = tableHeader[0];
    }

    // Add 5 empty rows at top
    for (let i = 1; i <= 5; i++) {
      worksheet.addRow([]);
    }

    // Add header row (row 6)
    const headerRow = worksheet.addRow(Object.values(headerData));
    
    // Add data rows
    Data.forEach(row => {
      worksheet.addRow(Object.values(row));
    });

    // Set column widths
    colwidth.forEach(col => {
      const colLetter = col.col;
      let colIndex;
      if (colLetter.length > 1) {
        // Handle AA, AB, etc
        const firstChar = colLetter.charCodeAt(0) - 64;
        const secondChar = colLetter.charCodeAt(1) - 64;
        colIndex = firstChar * 26 + secondChar;
      } else {
        colIndex = colLetter.charCodeAt(0) - 64; // A=1, B=2, etc
      }
      worksheet.getColumn(colIndex).width = col.width;
    });

    // Add headings
    Headings.forEach(heading => {
      worksheet.getCell(heading.col).value = heading.value;
    });

    // Parse title range and apply styling
    const titleRangeParts = titleWelderRange.split(':');
    const startCell = worksheet.getCell(titleRangeParts[0]);
    const endCell = worksheet.getCell(titleRangeParts[1]);
    
    for (let row = startCell.row; row <= endCell.row; row++) {
      for (let col = startCell.col; col <= endCell.col; col++) {
        worksheet.getCell(row, col).font = { bold: true, underline: true };
      }
    }

    // Style header row (row 6) - bold, center, borders
    headerRow.eachCell((cell) => {
      cell.font = { bold: true };
      cell.alignment = { horizontal: 'center', wrapText: true };
      cell.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' }
      };
    });

    // Style data rows with borders
    const dataStartRow = 7;
    const dataEndRow = dataStartRow + Data.length - 1;
    
    if (Data.length > 0) {
      for (let row = dataStartRow; row <= dataEndRow; row++) {
        for (let col = 1; col <= headerRow.cellCount; col++) {
          const cell = worksheet.getCell(row, col);
          cell.border = {
            top: { style: 'thin' },
            left: { style: 'thin' },
            bottom: { style: 'thin' },
            right: { style: 'thin' }
          };
        }
      }
    }

    // Freeze first 2 rows and hide gridlines
    worksheet.views = [{
      state: 'frozen',
      ySplit: 2,
      showGridLines: false
    }];

    // Generate and download file
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    });
    
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = fileName + '.xlsx';
    a.click();
    URL.revokeObjectURL(url);
    
  } catch (error) {
    console.error('Excel export failed:', error);
    throw error;
  }
}

